'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _breakpoints = require('../const/breakpoints');

var _config = require('../const/config');

var _errors = require('../errors');

var _predicate = require('../utils/predicate');

var SCOPES = _config.CONFIG_FIELD_NAMES.SCOPES,
    DATA = _config.CONFIG_FIELD_NAMES.DATA,
    RESOLVE = _config.CONFIG_FIELD_NAMES.RESOLVE;


var findResolvingScopes = function findResolvingScopes(breakpointName, data) {
  return (0, _ramda.pipe)((0, _ramda.prop)(SCOPES), (0, _ramda.filter)((0, _ramdaAdjunct.lensSatisfies)((0, _ramda.contains)(breakpointName), (0, _ramda.lensProp)(RESOLVE))), (0, _ramda.map)((0, _ramda.prop)(DATA)), _ramda.reverse, (0, _ramda.append)(data))(data);
};

var findDataPropOnScopes = function findDataPropOnScopes(data, dataPropName) {
  return function (breakpointName) {
    // Get scopes that resolve to this breakpoint
    // This will include the default in last position
    var resolvingScopes = findResolvingScopes(breakpointName, data);
    // Run through those scopes in reverse order, starting with the last and
    // ending witht the default, looking for the value.
    return (0, _ramda.reduce)(function (acc, scopeData) {
      var value = (0, _ramda.prop)(dataPropName, scopeData);
      if ((0, _ramda.isNil)(value)) {
        // Acc will either be our fully resolved object, or null
        return acc;
      }
      // If it is an object, we need to run through all scopes as some of its
      // properties might have been defined on an earlier scope.
      if ((0, _ramdaAdjunct.isObject)(value)) {
        if ((0, _ramdaAdjunct.isObject)(acc)) {
          // Merge any props that don't already exist on the object
          return (0, _ramda.merge)(value, acc);
        }
        // Save the object so we can keep looking for its props
        return value;
      }
      // If the value isn't an object then we have found our result.
      return (0, _ramda.reduced)(value);
    }, null, resolvingScopes);
  };
};

var findDataProp = function findDataProp(breakpointName, dataPropName) {
  return function (data) {
    // Optimise for early exit
    if ((0, _predicate.isDefaultBreakpoint)(breakpointName) || (0, _predicate.hasNoScopes)(data)) {
      return (0, _ramda.prop)(dataPropName, data);
    }
    return (0, _ramda.pipe)(findDataPropOnScopes(data, dataPropName), (0, _ramda.defaultTo)((0, _ramda.prop)(dataPropName, data)))(breakpointName);
  };
};

var keyToValueResolver = function keyToValueResolver(dataPropName) {
  return function (value, data) {
    var breakpointName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _breakpoints.DEFAULT_BREAKPOINT_NAME;
    return (0, _ramda.pipe)(findDataProp(breakpointName, dataPropName), (0, _ramda.when)(_ramdaAdjunct.isUndefined, function () {
      return (0, _errors.throwDataError)((0, _errors.missingDataNodeError)(dataPropName));
    }))(data);
  };
};
exports.default = keyToValueResolver;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/resolvers/keyToValueResolver.js
// module id = 176
// module chunks = 168707334958949